// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"693":"ad520a1c","787":"3ce35e2f","895":"94cd9a2d"}[chunkId] + ".chunk.js";
};